import { render } from "./Mitra.vue?vue&type=template&id=2d32b454"
import script from "./Mitra.vue?vue&type=script&lang=js"
export * from "./Mitra.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__